module.exports = __webpack_public_path__ + "img/polling_new.57922790.png";